import axios from "../api";
import { objectToParam } from "../../libs/utils";

export async function redeemParkingVoucher(
  registrationId,
  accessVoucherId,
  values
) {
  const { data } = await axios.post(
    `/registrations/${registrationId}/parking-vouchers/${accessVoucherId}/redeem`,
    values
  );
  return data;
}

export async function invalidateParkingVoucher(
  registrationId,
  accessVoucherId
) {
  const { data } = await axios.post(
    `/registrations/${registrationId}/parking-vouchers/${accessVoucherId}/invalidate`
  );
  return data;
}

export async function redeemParkingVoucherByBarcode(eventId, barcode, values) {
  const { data } = await axios.post(
    `events/${eventId}/redeem-parking-voucher/${barcode}`,
    values
  );
  return data;
}

export async function getParkingVouchers(registrationId, params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get(
    `registrations/${registrationId}/parking-vouchers?${parameters}`
  );
  return data;
}

export async function getParkingVoucherByBarcode(eventId, code) {
  const { data } = await axios.get(
    `events/${eventId}/parking-vouchers/${code}`
  );
  return data;
}

export async function getParkingStickers(eventId, params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get(
    `/events/${eventId}/parking-request-parking-stickers?${parameters}`
  );
  return data;
}

export async function claimParkingStickers(eventId, values) {
  const { data } = await axios.post(
    `events/${eventId}/claim-parking-stickers`,
    values
  );
  return data;
}
